import { Mp3Encoder } from 'lamejs';

class Recorder {
  constructor(config) {
    this.config = {
      bitRate: 128,
      bufferSize: 4096,
      sampleRate: 44100,
      channel: 1
    };
    Object.assign(this.config, config);

    this.context = null;
    this.microphone = null;
    this.encoder = null;
    this.audioNode = null;
    this.recording = false;
    this.mp3buffers = [];
    this.activeStream = null;
  }

  setup() {
    window.AudioContext = window.AudioContext || window.webkitAudioContext || AudioContext;
    //eslint-disable-next-line
    if (!(this.context = new window.AudioContext())) {
      console.log('Error: Unable to create audio context'); // eslint-disable-line no-console
    } else {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then(stream => {
            this.onAudioStream(stream);
            resolve(stream);
          })
          .catch(function (err) {
            console.log('Error: Unable to find audio support' + err); // eslint-disable-line no-console
            reject(err);
          });
      });
    }
  }

  onAudioStream(stream) {
    this.activeStream = stream;
    if (!(this.microphone = this.context.createMediaStreamSource(stream))) {
      console.log('Error: Unable to create audio stream source'); // eslint-disable-line no-console
    } else if (
      //eslint-disable-next-line
      !(this.encoder = new Mp3Encoder(
        this.config.channel,
        this.config.sampleRate,
        this.config.bitRate
      ))
    ) {
      console.log('Error: Unable to create Mp3Encoder'); // eslint-disable-line no-console
    } else if (
      !(this.audioNode = this.microphone.context.createScriptProcessor(
        this.config.bufferSize,
        this.config.channel,
        this.config.channel
      ))
    ) {
      console.log('Error: Unable to create audio processor node'); // eslint-disable-line no-console
    } else {
      this.audioNode.onaudioprocess = e => this.onAudioProcess(e);
      this.microphone.connect(this.audioNode);
      this.audioNode.connect(this.microphone.context.destination);
      this.recording = true;
    }
  }

  convertFloatToInt16(inFloat) {
    const sampleCount = inFloat.length;
    const outInt16 = new Int16Array(sampleCount);
    for (let n1 = 0; n1 < sampleCount; n1++) {
      //This is where I can apply waveform modifiers.
      let sample16 = 0x8000 * inFloat[n1];
      //Clamp value to avoid integer overflow, which causes audible pops and clicks.
      sample16 = sample16 < -32767 ? -32767 : sample16 > 32767 ? 32767 : sample16;
      outInt16[n1] = sample16;
    }
    return outInt16;
  }

  onAudioProcess(e) {
    const { inputBuffer } = e;
    const samples = inputBuffer.getChannelData(0);
    const samples16 = this.convertFloatToInt16(samples);
    if (samples16.length > 0) {
      const mp3buffer = this.encoder.encodeBuffer(samples16);
      if (mp3buffer.length > 0) {
        this.mp3buffers.push(mp3buffer);
      }
    }
  }

  stop() {
    this.audioNode.onaudioprocess = null;
    this.microphone.disconnect(this.audioNode);
    this.audioNode.disconnect();
    this.recording = false;
    const mp3Buffer = this.encoder.flush();
    if (mp3Buffer.length > 0) this.mp3buffers.push(mp3Buffer);
    this.context.close();
    this.activeStream.getAudioTracks().forEach(track => track.stop());
    return this;
  }

  getMp3() {
    return new Promise((resolve, reject) => {
      if (this.mp3buffers.length === 0) {
        reject(new Error('No buffer to send'));
      } else {
        resolve([this.mp3buffers, new Blob(this.mp3buffers, { type: 'audio/mpeg' })]);
      }
    });
  }
}

export default Recorder;
